import { svg } from 'lit';
import { bounds } from '../types.js';
import { KeyScale } from '../axis/key/KeyScale.js';
export function DebugKeyBands({
  bounds,
  keyScale
}: {
  bounds: bounds;
  keyScale: KeyScale;
}) {
  return svg`
    <g transform="translate(0, 0)" fill="none" class="key-bands">
      ${keyScale.keys.map((key, i) => {
    return svg`
          <rect
            width=${keyScale.size}
            height=${bounds.bottom - bounds.top}
            x=${keyScale.position(key)}
            y=${bounds.top}
            fill=${i % 2 == 0 ? 'var(--one-ux-palette--green-200)' : 'var(--one-ux-palette--green-100)'}
          >
          </rect>
        `;
  })}
    </g>
  `;
}